const noForwardImg = 'https://image.wxopen.shenhudong.com/images/no-forward.svg'
const noRecommendImg = 'https://image.wxopen.shenhudong.com/images/no-recommend.svg'
const noViews = 'https://image.wxopen.shenhudong.com/images/no-views.svg'
import style from './index.module.styl'

import { RecordDialog } from '@/components/dialog'
import API from '@/api'

export const NoContent = {
  functional: true,
  props: ['img', 'text'],
  render(h, context) {
    return (
      <div class={style.noContent}>
        <img class={style.img} src={context.props.img} />
        <span class={style.text}>{context.props.text}</span>
      </div>
    )
  }
}

export default {
  components: {
    RecordDialog
  },
  data() {
    return {
      pageIndex: 0,
      activeIndex: 0,
      visible: false,
      behaviorCount: {},
      behaviorList: [],
      canMore: false,
      recommendUid: ''
    }
  },
  async created() {
    try {
      await this.getBehaviorInfo()
    } catch (error) {
      console.error(error)
    }
  },
  methods: {
    async getBehaviorInfo() {
      try {
        this.$vux.loading.show({text: '加载中'})
        const resp = await this.$http({
          method: 'POST',
          url: API.getBehavior,
          params: {
            page: this.pageIndex,
            activity_id: this.$route.params.eventId,
            token: this.$storage.getItem('token'),
            openid: this.$storage.getItem('openid'),
            type: +this.activeIndex + 1
          }
        })

        Object.assign(this.behaviorCount, resp.behaviorCount) 
        this.behaviorList = this.pageIndex === 0 ? resp.behaviorList : [...this.behaviorList, ...resp.behaviorList]
        this.canMore = resp.canMore
      } catch (error) {
        console.error(error)
      } finally {
        this.$vux.loading.hide()
      }
    },
    handleLoadMore() {
      this.pageIndex ++
      this.getBehaviorInfo()
    },
    handleClickNavItem(e) {
      const { index } = e.currentTarget.dataset
      this.pageIndex = 0
      this.activeIndex = Number(index)
      this.getBehaviorInfo()
    },
    handleCloseDialog() {
      this.visible = false
    },
    handleOpenDialog(e) {
      this.recommendUid = e.currentTarget.dataset.uid
      this.visible = true
    }
  },
  render(h) {
    window.document.title = '记录'
    const navItemClass = index => ({
      [style.navItem]: true,
      [style.active]: index === this.activeIndex
    })
    const { browsing, redbag, points } = this.$store.state.currentActivity
    
    return (
      <div class={style.record}>
        <div class={style.topTips} style={this.$route.params.eventId == 309878?'background-color:rgb(234,23,36)':''}>您在本活动的有效浏览{browsing}人，获得红包{redbag}元，{this.$store.state.keyword}{points}分</div>
        <div class={style.navBar}>
          <div class={navItemClass(0)} data-index="0" onClick={this.handleClickNavItem}>
            <div class={style.name}>有谁看过</div>
            <div class={style.num}>{this.behaviorCount['1']}</div>
          </div>
          <div class={navItemClass(1)} data-index="1" onClick={this.handleClickNavItem}>
            <div class={style.name}>有意向的</div>
            <div class={style.num}>{this.behaviorCount['2']}</div>
          </div>
          <div class={navItemClass(2)} data-index="2" onClick={this.handleClickNavItem}>
            <div class={style.name}>推荐成功</div>
            <div class={style.num}>{this.behaviorCount['3']}</div>
          </div>
        </div>
        {
          !!this.behaviorList.length && (
            <div class={style.list}>
              {
                this.behaviorList.map(item => (
                  <div key={item.id} data-uid={item.user_id} class={style.listItem} onClick={this.handleOpenDialog}>
                    <img src={item.avatar} class={style.avatar} />
                    <div class={style.rightPart}>
                      <div class={style.topLine}>
                        <div class="name">{item.nickname}</div>
                        <div class="desc">{item.status}</div>
                      </div>
                      <div class={style.bottomLine}>
                        <div class={style.action}>{item.desc}</div>
                        <div class={style.time}>{item.created_at}</div>
                      </div>
                    </div>
                  </div>
                ))
              }
            </div>
          )
        }
        
        {
          !!this.behaviorList.length && (
            this.canMore ? (
              <div class={style.bottomTips} onClick={this.handleLoadMore}>
                <span class={style.line}></span>
                <span class={style.text}>加载更多</span>
                <span class={style.line}></span>
              </div>
            ) : (
              <div class={style.bottomTips}>
                <span class={style.line}></span>
                <span class={style.text}>全部加载</span>
                <span class={style.line}></span>
              </div>
            )
          )
        }
        {
          (!this.behaviorList.length && this.activeIndex === 0)&& (
            <NoContent img={noViews} text="好友还没看过，快去分享吧" />
          )
        }
        {
          (!this.behaviorList.length && this.activeIndex === 1) && (
            <NoContent img={noForwardImg} text="还没有好友" />
          )
        }
        {
          (!this.behaviorList.length && this.activeIndex === 2) && (
            <NoContent img={noRecommendImg} text="好友采纳了你的推荐，会有惊喜哦" />
          )
        }
        <record-dialog
          onClickCloseBtn={this.handleCloseDialog}
          visible={this.visible}
          recommendUid={this.recommendUid}
        />
      </div>
    )
  }
}